
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Tree,
  Button,
} from 'element-ui';
import BS from '@/views/Home/mixins/bsMixin';
import api from '@/api/org';

type Loading<T> = {
  view: T,
  btn: T,
}

@Component({
  components: {
    Dialog,
    Button,
    Tree,
  },
})
export default class ModuleModal extends Mixins(BS) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '模块管理',
  }) title!: string;

  private props: {label: string, children: string} = {
    label: 'label',
    children: 'children',
  }

  private data:any = [];

  private checkedKeys: string[] = [];

  private form: any = {};

  private loading: Loading<boolean> = {
    view: false,
    btn: false,
  };

  public $refs!: {
    tree: Tree,
  }

  mounted() {
    this.getModule(this.$route.params.pid || '');
  }

  get vis() {
    if (this.visible) {
      this.$nextTick(() => {
        this.initBS('.el-dialog__body');
      });
    }
    return this.visible;
  }

  reset(close: boolean) {
    if (close) this.$emit('update:visible', false);
  }

  getModule(orgPid: string) {
    this.loading.view = true;
    api.getModule({ orgPid }).then((res: any) => {
      this.checkedKeys = [];
      const tree: any = [];
      res.forEach((elem:any) => {
        if (!elem.moduleFolder) {
          const children:any = {};
          children.pid = elem.pid;
          children.label = elem.moduleTitle;
          children.children = [];
          res.forEach((element: any) => {
            if (elem.modulePath.includes(element.moduleFolder) && element.moduleFolder) {
              const child:any = {};
              child.pid = element.pid;
              child.label = element.moduleTitle;
              child.children = [];
              children.children.push(child);
              if (element.checked) {
                this.checkedKeys.push(child.pid);
              }
            }
          });
          tree.push(children);
        }
      });
      this.data = tree;
      this.loading.view = false;
    });
  }

  submit() {
    this.loading.btn = true;
    this.form.orgPid = this.$route.params.pid || '';
    // this.form.modulePidList = this.$refs.tree.getCheckedKeys(false);
    const key = this.$refs.tree.getCheckedNodes(false, true)
    this.form.modulePidList = key.map((el: any) => el.pid);
    const data = new FormData();
    data.append('orgPid', this.form.orgPid);
    data.append('modulePidList', this.form.modulePidList);
    api.alloctModule(data).then(() => {
      this.reset(true);
      this.loading.btn = false;
    /* eslint-disable no-return-assign */
    }).catch(() => (this.loading.btn = false));
  }
}
